import { UIStatus } from "../../types/GlobalTypes";
import { OnmetaStatus, Wallet } from "../../types/WalletTypes";

export type StatusMessageValue = [
  UIStatus,
  string | ((criteria: boolean) => string),
];

const messages: Record<OnmetaStatus, StatusMessageValue | boolean> = {
  [OnmetaStatus.N_A]: false,
  [OnmetaStatus.PENDING]: [
    UIStatus.WARNING,
    (criteria) =>
      criteria
        ? "Verifying account details. Please wait."
        : "You must complete both Identity Verifications",
  ],
  [OnmetaStatus.SUCCESS]: false,
  [OnmetaStatus.FAILED]: [
    UIStatus.ERROR,
    "Failed to verify Bank details (likely wrong beneficiary name or details). Reach out to support, or click above to add a new INR wallet instead",
  ],
};

export const validateWalletOnmetaStatus = (
  wallet?: Wallet
): StatusMessageValue | boolean => {
  return messages[wallet?.onmeta_status || OnmetaStatus.N_A];
};
